const CREDIARC_BRAND = Object.freeze({
  name: "CrediArc",
  logoUrl: "/logo.svg",
  logoAlt: "CrediArc",
  logoSx: { height: 24 },
});

const EIA_GLOBAL_BRAND = Object.freeze({
  name: "EIA Global",
  logoUrl: "https://eia-global.com/wp-content/uploads/2025/03/eai-global-logo.webp",
  logoAlt: "EIA Global",
  logoSx: {
    width: 56,
    height: 42,
    objectFit: "contain",
    backgroundColor: "#fff",
    borderRadius: "4px",
    p: "2px",
  },
});

const GALLAGHER_BRAND = Object.freeze({
  name: "Gallagher",
  logoUrl: "https://www.ajg.com/au/-/media/images/gallagher/us/logos/gallagher_horizontalsmall-3d.svg?hash=682DE2FF08F590D439CAADE396065C42&iar=0",
  logoAlt: "Gallagher",
  logoSx: {
    maxWidth: 150,
    height: 42,
    objectFit: "contain",
    backgroundColor: "#fff",
    borderRadius: "4px",
    p: "3px 6px",
  },
});

const brandKey = (value) => String(value || "")
  .trim()
  .toLowerCase()
  .replace(/[^a-z0-9]+/g, "-")
  .replace(/^-+|-+$/g, "");

export function getDistributorBrand(distributor) {
  if (distributor?.logoUrl) {
    return {
      name: distributor.name || "Distributor",
      logoUrl: distributor.logoUrl,
      logoAlt: distributor.name || "Distributor",
      logoSx: { maxWidth: 150, height: 42, objectFit: "contain" },
    };
  }
  const keys = [distributor?.id, distributor?.name].map(brandKey);
  const isEiaGlobal = keys.some((key) => key === "eia" || key === "eia-global" || key.startsWith("eia-global-"));
  if (isEiaGlobal) return EIA_GLOBAL_BRAND;
  const isGallagher = keys.some((key) =>
    key === "ajg" || key === "gallagher" || key.startsWith("gallagher-") || key.startsWith("arthur-j-gallagher")
  );
  if (isGallagher) return GALLAGHER_BRAND;
  if (distributor) return { name: distributor.name || "Distributor", logoUrl: null, logoAlt: distributor.name || "Distributor", logoSx: {} };
  return CREDIARC_BRAND;
}
